import Action from 'redux/helpers/createAction'
const name = 'tour'

export const openTour = Action(name + '/OPEN_TOUR')
export const closeTour = Action(name + '/CLOSE_TOUR')

export const setTourSteps = Action(name + '/SET_TOUR_STEPS', steps => ({
  steps
}))

export const resetTour = Action(name + '/RESET_TOUR')
